// ...existing code...
import { useAccessToken } from "hooks/useAccessToken";
import useAlert from "hooks/useAlert";
import { useMutation, useQueryClient } from "react-query";
import { BACKEND_DOMAIN } from "utils/constants";
import { showMutationAlert } from "utils/helpers";
import { documentsQueryKey } from "./queryListDocuments";

const useDeleteDocuments = (buildingModelUid: string) => {
    const alert = useAlert();
    const accessToken = useAccessToken();
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async (upload_uid: string) => {
            const URL = `${BACKEND_DOMAIN}/buildings/${buildingModelUid}/documents/${upload_uid}`;
            const response = await fetch(URL, {
                method: "DELETE",
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });
            if (!response.ok) {
                throw new Error(`Error ${response.status}`);
            }
            return response.json();
        },
        onSuccess: () => {
            queryClient.invalidateQueries([...documentsQueryKey, buildingModelUid]);
        },
        onError: (error) => {
            showMutationAlert(error, alert);
        },
    });
}

export default useDeleteDocuments